import * as React from 'react';
import { UIHeading2, UIText1, Button, useDeviceType } from '@cian/ui-kit';

import * as style from './Error.css';

export interface INewReviewModalErrorProps {
  type: string;
  retry?(): void;
  onClose?(): void;
}

export const Error: React.FC<INewReviewModalErrorProps> = props => {
  const { retry, onClose } = props;
  const deviceType = useDeviceType();
  const isMobile = deviceType === 'phone';

  return (
    <div data-testid="Error" data-name="Error" className={style['container']}>
      <div className={style['content']}>
        <div className={style['header']}>
          <UIHeading2>
            Не получилось,
            <br />
            попробуйте еще раз
          </UIHeading2>
        </div>
        <div className={style['text']}>
          <UIText1>{props.type} сохранён, но пока не отправился</UIText1>
        </div>
        <div className={style['action']}>
          {retry && (
            <div>
              <Button fullWidth={isMobile} size={isMobile ? 'M' : 'XS'} onClick={retry}>
                Опубликовать
              </Button>
            </div>
          )}
          {onClose && (
            <div>
              <Button fullWidth={isMobile} size={isMobile ? 'M' : 'XS'} onClick={onClose}>
                Закрыть
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
